module.exports = "https://static.energy5.com/_next/static/images/sonnen-15bc26c9d30ff1b30460f45677b23e9c.png";